import React,{ useRef } from 'react';
import axios from 'axios'
import { Tooltip,Popover,Result,Table,Popconfirm,Input, Button,Collapse,Card,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { DeleteOutlined,SearchOutlined,CameraOutlined,PlusOutlined,EditOutlined,PlusSquareFilled,SaveOutlined,LoadingOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import {
  Col,
  Row,
} from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import * as reactstrp from 'reactstrap';
import { ToWords } from 'to-words';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const toWords = new ToWords();

message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});


var sacco= ''
var username=''
var token= ''
var bizuserid= ''

class ReceiptToPrint extends React.Component {

  state = {
    companyprofile:{}
  };

  componentDidMount(){

    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
    
    }else{
       sacco= ''
       username=''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

 

  }

  render() {
    return (
      <div style={{padding:20}}>
            
          <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
          <h3 style={{color:'black'}}>{this.state.companyprofile.sacco_name}-{this.state.companyprofile.branchname}</h3>
          <h6 style={{color:'black'}}>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
          {
          this.state.companyprofile.RegisteredPhoneNumber2==""?
          "":","+this.state.companyprofile.RegisteredPhoneNumber2
          }
          {
          this.state.companyprofile.RegisteredPhoneNumber3==""?
          "":","+this.state.companyprofile.RegisteredPhoneNumber3
          }
          </h6>               
          <h5 style={{color:'black'}}>Email: {this.state.companyprofile.company_email}</h5>
          <h5 style={{color:'black'}}>Wesite: {this.state.companyprofile.website}</h5>
          <h5 style={{color:'black'}}>{this.state.companyprofile.box_number}</h5>
           <h4 style={{color:'black'}}>DATE: {this.props.date}</h4>
           <h5 style={{color:'black'}}>Country: {this.state.companyprofile.country} || Currency: {this.state.companyprofile.currency}</h5>
           <h3 style={{strong:true,color:'black',fontWeight:'bolder'}}>WITHDRAW RECEIPT</h3>

           <table cellpadding="2" cellSpacing="2" border="1">
            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>ACC NUMBER</td>
              <td style={{fontWeight:'bold'}}>{this.props.account.AccountNumber}</td>
            </tr>

            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>ACC NAME</td>
              <td style={{fontWeight:'bold'}}>{this.props.account.FullName}</td>
            </tr>  

            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>WITHDRAWN AMOUNT</td>
              <td style={{fontWeight:'bold'}}><CurrencyFormat  value={this.props.paidamount} displayType={'text'} thousandSeparator={true} /></td>
            </tr> 

            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>In Words</td>
              <td style={{fontWeight:'bold'}}>{ toWords.convert(this.props.paidamount)}</td>
            </tr> 

            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>WITHDRAWN BY</td>
              <td style={{fontWeight:'bold'}}>{this.props.paidinby}</td>
            </tr> 

            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>SLIP NUMBER</td>
              <td style={{fontWeight:'bold'}}>{this.props.slipnumber}</td>
            </tr> 

            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>CONTACT</td>
              <td style={{fontWeight:'bold'}}>{this.props.transactorcontact}</td>
            </tr> 

            <tr style={{height:40,padding:1}} key={1}>
              <td style={{fontWeight:'bolder'}}>TELLER</td>
              <td style={{fontWeight:'bold'}}>{username}</td>
            </tr> 

           </table>

    </div>
    );
  }
}



class AccountWithdrawView extends React.Component {

  state = {
    date:moment().format(dateFormat).toString(),
    selectedaccount:'',
    selectedaccountobject:{},
    members:[],
    datarequested:true,
    paidamount:0,
    paidinby:'',
    transactorcontact:'',
    datasubmittedsuccessfully:false,
    withdrawcharges:0,
    accountchange:false,
    companyprofile:{},
    userprofile:{},

    companyaccounts: [],
    creditaccount:'',
    finaldebit_account:'',
    bankcharges:0

  }

  callback(key) {
    console.log(key);
  }

  componentDidMount(){
      if(localStorage.getItem("sacco")){
        sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
        username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
    
    }else{
        sacco= ''
        username=''
    }
    
    if(localStorage.getItem("token")){
        token= localStorage.getItem("token")
    }else{
        token= ''
    }

    if(localStorage.getItem("bizuserid")){
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
   }else{
      bizuserid= ''
   }
    
    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    let form_data1 = new FormData();
    form_data1.append('userid', bizuserid);
    
    //get the user profile here
    axios.post(serverconfig.backendserverurl+'/customqueries/get_user_profile',form_data1,{
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
    .then(res => {
        this.setState({
          userprofile:res.data
        })
     
    })


    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

    axios.get(serverconfig.backendserverurl+`/api/members/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          members:res.data
        })

    })


      axios.get(serverconfig.backendserverurl+`/api/user_saccoaccounts/?user=${bizuserid}`)
      .then(res => {
          this.setState({
              companyaccounts:res.data
          })
          this.setState({datarequested:false})
      })

  }

  

  
  ////////////////////////////////////
  // PRODUCT SEARCH SELECT METHODS
   onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }

  //handle client change
  handleselectedaccountChange= (e) =>{
    this.setState({accountchange:true})

    this.setState({selectedaccountobject:{}})
    this.setState({withdrawcharges:0})

    this.setState({ selectedaccount: e});
    //make query for last transactions
    axios.get(`${serverconfig.backendserverurl}/api/members/${e}`)
      .then(res => {  
          this.setState({selectedaccountobject: res.data})
          this.setState({withdrawcharges:res.data.savings_withdraw_charges})
      })

      this.setState({accountchange:false});

  }

  handlepaidinbyChange= (e) => this.setState({ paidinby: e.target.value});
  handleamountChange= (e) => this.setState({ paidamount: e});
  handletransactorcontactChange= (e) => this.setState({ transactorcontact: e});



  //submit the deposit now
  handleFormSubmit=(event) =>{

      if(Number(this.state.paidamount)>this.calculateNetWithdraw()){
        message.error("Amount cant be greater than net withdrawal")
      }else if(this.state.companyprofile.userbalancesfeature===true && this.calculateNetWithdraw()>Number(this.state.userprofile.User_balance) ){
        message.error("Less User balance .You cant make this transaction")
      }else if(this.state.selectedaccountobject.account_status!="active"){
        message.error("Account is not active")

      }else{
        this.setState({datarequested:true})
        console.log(username)
  
      let form_data = new FormData();
      form_data.append('date',this.state.date);
      form_data.append('paidinby', this.state.paidinby);
      form_data.append('paidamount', this.state.paidamount);
      form_data.append('transactorcontact', this.state.transactorcontact);
      form_data.append('sacco', sacco);
      form_data.append('account', this.state.selectedaccountobject.id);
      form_data.append('username', username);
      form_data.append('charges', this.state.withdrawcharges);
      form_data.append('userid', bizuserid);
      form_data.append('creditaccount', this.state.finaldebit_account);
      form_data.append('journaltotal', this.state.paidamount);
      form_data.append('bankcharges', this.state.bankcharges);

      axios.post(serverconfig.backendserverurl+'/customqueries/createaccountwithdraw', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }})
      .then(res => {
        this.setState({datarequested:false})
        message.info(res.data.message)
        if (res.data.message==="success"){
          this.setState({datasubmittedsuccessfully:true})
        }
        
      })
      .catch(error => console.log(error))
      }
  
  }


  //calculate Netwithdraw
  calculateNetWithdraw=()=>{
    var netwithdraw=0
    var minimumaccountbal=Number(this.state.selectedaccountobject.minimum_savings_balance)
    var withdrawcharge=Number(this.state.selectedaccountobject.savings_withdraw_charges)

    netwithdraw=Number(this.state.selectedaccountobject.savings_balance)-(minimumaccountbal+withdrawcharge+Number(this.state.bankcharges))

    return netwithdraw;
  }


  ////////////////////////////////////////////
  // RENDERING METHOD HERE
  render() {

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      if(this.state.datasubmittedsuccessfully===true){
        return(
          <div>
            <div style={{display: "none"}}>
            &nbsp;&nbsp;
            <ReceiptToPrint
            account={this.state.selectedaccountobject} 
            paidamount={this.state.paidamount} 
            paidinby={this.state.paidinby} 
            transactorcontact={this.state.transactorcontact}
            date={this.state.date}
            ref={el => (this.componentRef = el)} /> 
            </div>

            <Row >
                  <Col xs="12" sm="6" lg="6">
                    <Card>
                    <Result
                    status="success"
                    title="Successfully Withdrawn "
                    subTitle="Please print receipt or finish off transaction"
                    extra={[
                      <a>
                      <ReactToPrint
                        trigger={() =>                     
                          <div style={{}}>
                            <Tooltip title="Click to print" placement="top">
                            <p ><PrinterOutlined style={{ fontSize: '40px', color: '#08c' }}/></p>
                            <h6 >Print Receipt</h6>
                            </Tooltip>
                          </div>                          
                            }
                            content={() => this.componentRef}
                          />  
                          </a>,
                      <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
                    ]}
                    />

                  </Card>
                  </Col>
            </Row>
          </div>
        )

      }else{
        return(
          <div>
            <div>
  
              <Row >
                  <Col xs="12" sm="6" lg="6">
                    <Card style={{display:'flex',justifyContent:'center',alignSelf:'center'}}>
                  
                    <h4 style={{fontStyle:'oblique',fontWeight:'bolder'}}>Account To Withdraw From</h4>
                    <FormItem label="Account">
                        <Select 
                        placeholder="Account No | Name" 
                        style={{  }} 
                        value={this.state.selectedaccount}
                        onChange={this.handleselectedaccountChange} 
                        showSearch
                        optionFilterProp="children"
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onSearch={this.onSearch}                  
                        >
                          {this.state.members.map(
                            (accnt)=>(
                              <Option value={accnt.id}>{accnt.AccountNumber} | {accnt.FullName}</Option>
                            ))}
                        </Select>
                    </FormItem>
                    {
                      this.state.accountchange?
                      <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
                      <Spin indicator={antIcon} />
                      </div>
                      :
                      null
                    }


                    <h3 style={{fontWeight:'bold',alignSelf:'center',color:'#154360'}}>WITHDRAW FORM</h3>

                 

                      <Form
                      onFinish={(event) => this.handleFormSubmit(event)}
                  >

                  {
                    this.state.companyprofile.automated_transaction_date===false?
                    <FormItem label="Date"
                      name='date'
                      rules={[
                        {
                          required: true,
                          message: 'Please Select date',
                        },
                      ]}
                    >
                        <DatePicker value={moment()} onChange={(date, dateString)=>{this.setState({ date: dateString})}} format={dateFormat} />
                    </FormItem>
                  :
                  null
                  }


                    <FormItem label={<h4 style={{fontWeight:'bold'}}>Amount</h4>}
                    name="amount"
                    rules={[
                      {
                        required: true,
                        message: 'Please input amount',
                      },
                    ]}
                    
                    >
                      <InputNumber
                        style={{ width: 200 }} 
                        defaultValue={0.0}
                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/\x\s?|(,*)/g, '')}
                        onChange={this.handleamountChange}
                      />    
                                  
                    </FormItem>
  
                    <FormItem label={<h4 style={{fontWeight:'bold'}}>Withdrawn By:</h4>}
                    name="paidinby"
                    rules={[
                      {
                        required: true,
                        message: 'Please input name',
                      },
                    ]}
                    
                    >
                      <Input name="paidinby"  placeholder="Name" value={this.state.paidinby} onChange={this.handlepaidinbyChange}/>
     
                    </FormItem>
  
                    <FormItem 
                      label={<h4 style={{fontWeight:'bold'}}>Transactor Contact:</h4>}
                      >
                    <PhoneInput
                      countrySelectProps={{ unicodeFlags: true }}
                      defaultCountry="UG"
                      placeholder="Enter phone"
                      value={this.state.transactorcontact}
                      onChange={this.handletransactorcontactChange}
                      />
                  </FormItem> 
  

                  {
                    this.state.selectedaccountobject.showeditablewithdrawcharge?
                    <FormItem label={<h4 style={{fontWeight:'bold'}}>Withdraw Charge:</h4>}>
                    <Input name="withdrawcharge"  placeholder="0" value={this.state.withdrawcharges} onChange={(val)=>{this.setState({withdrawcharges:val.target.value})}}/>
                    </FormItem>
                    :
                    null
                  }


                  <FormItem label="Bank charges">
                         <Input name="bankcharges" type='number'  placeholder="bankcharges." value={this.state.bankcharges} onChange={(val)=>{this.setState({bankcharges:val.target.value})}} />
                  </FormItem>

                  <FormItem label={<h4 style={{fontWeight:'bold'}}>Pay A/C (Credit A/C).</h4>}
                    name="creditaccount"
                    rules={[
                      {
                        required: true,
                        message: 'Please select account',
                      },
                    ]}
                  >
                        <Select 
                        placeholder="Account" 
                        style={{  }} 
                        value={this.state.creditaccount}
                        onChange={(val)=>{
                          this.setState({creditaccount:val})
                        
                          //get final debit account
                          axios.get(`${serverconfig.backendserverurl}/api/user_saccoaccounts/${val}`)
                          .then(res => {  
                              this.setState({
                                  finaldebit_account: res.data.company_account
                              })
                          })
                        
                        }} 
                        showSearch
                        optionFilterProp="children"
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onSearch={this.onSearch}                    
                        >
                          {this.state.companyaccounts.map(
                            (accnt)=>(
                              <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
                            ))}
                        </Select>
                    </FormItem>             


                    <FormItem style={{alignSelf:'flex-end'}}>
                      <Button  type="primary" htmlType="submit">Submit</Button>
                    </FormItem>
                    </Form>
  
                    </Card>
                   
                  </Col>
  
                 <Col xs="12" sm="6" lg="6">
                   <Card>

                   <h3 style={{fontWeight:'bold',color:'#154360'}}>Account Details</h3>
                    <h4>Account Number:{this.state.selectedaccountobject.AccountNumber}</h4>
                    <h4>Account Name:{this.state.selectedaccountobject.FullName}</h4>
                    <h4>Account Contact:{this.state.selectedaccountobject.RegisteredPhoneNumber1}</h4>
                    <h4>Savings Account Balance:<CurrencyFormat value={this.state.selectedaccountobject.savings_balance} displayType={'text'} thousandSeparator={true}  /> </h4>
                    <h4>Status:{this.state.selectedaccountobject.account_status}</h4>
                    <h4>Net Withdraw:<CurrencyFormat value={this.calculateNetWithdraw()} displayType={'text'} thousandSeparator={true}  /> </h4>
                    <h4>Withdraw Charges:<CurrencyFormat value={this.state.withdrawcharges} displayType={'text'} thousandSeparator={true}  /> </h4>
                    <h4>Savings loan security balance:<CurrencyFormat value={this.state.selectedaccountobject.savingsloan_security_balance} displayType={'text'} thousandSeparator={true}  /> </h4>

                   </Card>
   
                </Col>
            </Row>
  
            </div>
  
  
       </div>              
                      
        )
      }


    }
   
  }
}

export default AccountWithdrawView; 
